// @flow
import Axios from 'axios'
import {getCookie, graphQLURL, graphQLToken} from '../../utils/common';
// update posts
export const UPDATE_LIST_POSTS = 'posts:updateListPosts'
export type UPDATE_LIST_POSTS_TYPE = {
  type: 'posts:updateListPosts',
  payload: { allPosts: Object[] }
}

export const updateListPosts = (allPosts: Object[]): UPDATE_LIST_POSTS_TYPE => ({
  type: UPDATE_LIST_POSTS,
  payload: { allPosts }
})

// fetching status and error
export const UPDATE_LIST_POSTS_STATUS = 'posts:updateListPostsStatus'
export type UPDATE_LIST_POSTS_STATUS_TYPE = {
  type: 'posts:updateListPostsStatus',
  payload: {
    isFetching: boolean,
    error: null | string
  }
}

export const updateListPostsStatus = (isFetching: boolean, error: null | string): UPDATE_LIST_POSTS_STATUS_TYPE => ({
  type: UPDATE_LIST_POSTS_STATUS,
  payload: {
    isFetching,
    error
  }
})

// get data
export const getListPosts = (dispatch: Function) => {

  // set fetching
  dispatch(updateListPostsStatus(true, null))

  // GraphQL
  const query = {
    query: `
      query allPosts($first: Int, $skip: Int) {
        allPosts(orderBy: dateAndTime_DESC, first: $first, skip: $skip) {
        id
        slug
        title
        dateAndTime
        content
      }
    }`
  }
  const CONTENT_TYPE = { 'Content-Type': 'application/json' }

  Axios.post('https://api.graphcms.com/simple/v1/optionsedugraph', query, { headers: CONTENT_TYPE })
    .then((res: Object) => {

      // set fetching false and add data
      dispatch(updateListPostsStatus(false, null))
      dispatch(updateListPosts(res.data.data.allPosts))
    })
    .catch((err: Object) => {
      
      // set fetching false and add error
      dispatch(updateListPostsStatus(false, 'Unable to Get Posts'))
    })
}

export const getCountries = () => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL
  const token = getCookie('securityToken') || graphQLToken
  const query = {
    query: `
      query {
        countries {
          id
          countryname
          countrycode
          phonecode
        }
    }`
  }
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  return Axios.post(apiUrl, query, { headers: CONTENT_TYPE }).catch(err => null);
}

export const getPromotionalContents = () => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL
  const token = getCookie('securityToken') || graphQLToken
  const query = {
    query: `
      query {
         promotionalContents {
            name
            roles
            id
            url
            startDate
            description
            endDate
         }
    }`
  }
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  return Axios.post(apiUrl, query, { headers: CONTENT_TYPE }).catch(err => null);
}



// WEBPACK FOOTER //
// ./src/actions/posts/index.js